/* eslint-disable no-unused-expressions */
import React from "react";
import GlobalForm from "../../components/globalForm/GlobalForm";
import Loading from "../../components/shared/loading/Loading";
import { updateData } from "../../hooks/update";
import useFetch from "../../hooks/useFetch";

import { apiPath } from "../../utility/Constant";

const ContactPage = () => {
  const { footerApi } = apiPath;
  const [footer, footerLoading] = useFetch(footerApi);

  if (footerLoading) {
    return <Loading />;
  }
  const {
    contactUsBg,
    contactUsSubTitle,
    contactUsTitle,
    mapUrl,
    mapImg,
    address,
    phone,
    email,
  } = footer;

  const contactData = [
    {
      elementType: "file",
      label: "Banner Image",
      type: "file",
      name: "contactUsBg",
      defaultValue: contactUsBg,
      required: true,
    },
    {
      elementType: "input",
      label: "Banner Title",
      type: "text",
      name: "contactUsTitle",
      defaultValue: contactUsTitle,
      required: false,
    },
    {
      elementType: "input",
      label: "Contact Us Heading",
      type: "text",
      name: "contactUsSubTitle",
      defaultValue: contactUsSubTitle,
      required: false,
    },
    {
      elementType: "file",
      label: "Map Image",
      type: "text",
      name: "mapImg",
      defaultValue: mapImg,
      required: false,
    },
    {
      elementType: "input",
      label: "Map Location URL",
      type: "text",
      name: "mapUrl",
      defaultValue: mapUrl,
      required: false,
    },
    {
      elementType: "textField",
      label: "Address",
      type: "Text",
      name: "address",
      defaultValue: address,
      required: false,
    },
    {
      elementType: "input",
      label: "Phone Number",
      type: "text",
      name: "phone",
      defaultValue: phone,
      required: false,
    },
    {
      elementType: "input",
      label: "Email",
      type: "email",
      name: "email",
      defaultValue: email,
      required: false,
    },
  ];

  const update = (data) => {
    updateData(footerApi, data);
  };

  return (
    <div>
      <GlobalForm data={contactData} update={update} />
    </div>
  );
};

export default ContactPage;
